import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFullInventoryContentForm,
    type StockFullInventoryContentFormProps,
} from "./components/StockFullInventoryContentForm/StockFullInventoryContentForm";

/** Окна карточки полной инвентаризации склада. */
export const stockFullInventoryCardWindows = {
    content: defineMobileFormWindow<StockFullInventoryContentFormProps>({
        key: "stock.fullInventory.content",
        title: "Инвентаризация",
        component: StockFullInventoryContentForm,
    }),
};
